/** Maps email template send grid model to email template send grid DTO. */
export const emailTemplateSendGridMapper = ({
  activity,
  buyerId,
  projectId,
  templateName,
  file,
  htmlSource,
  subject,
  fromName,
  fromEmail,
}) => {
  if (file) {
    const emailTemplatesSendGrid = new FormData();

    emailTemplatesSendGrid.append('activity', activity);
    emailTemplatesSendGrid.append('buyer_id', buyerId);
    emailTemplatesSendGrid.append('project_id', projectId);
    emailTemplatesSendGrid.append('template_name', templateName);
    emailTemplatesSendGrid.append('subject', subject);
    emailTemplatesSendGrid.append('from_name', fromName);
    emailTemplatesSendGrid.append('from_email', fromEmail);
    emailTemplatesSendGrid.append('file', file);

    return emailTemplatesSendGrid;
  }

  const emailTemplatesSendGrid = {
    activity,
    buyer_id: buyerId,
    project_id: projectId,
    template_name: templateName,
    html_source: htmlSource,
    subject,
    from_name: fromName,
    from_email: fromEmail,
  };

  return emailTemplatesSendGrid;
};
